import type { EntityOptionFieldType } from "@entrilia/shared/api/dictionaryTypes";
import { logError } from "@entrilia/shared/logging";
import useClientContext from "../../../context/useClientContext";
import { getSelectOptionsFromDictionary } from "../../../utilities/dictionariesHelper";
import type { EntityFieldComponentProps, EntityFieldComponentPropsBase } from "../entityFieldTypes";
import { getInvalidFieldValueError } from "../helpers";
import EntityFieldSelectComponent from "./EntityFieldSelectComponent";

const EntitySelectField = ({
  value,
  fieldId,
  fieldConfiguration,
  fieldAttributes,
  onChange,
  fieldInputId,
}: EntityFieldComponentPropsBase) => {
  if (typeof value !== "string" && value !== undefined && value !== null) {
    logError(getInvalidFieldValueError(fieldId, fieldConfiguration?.$type, value), "[EntitySelectField]");
    return null;
  }

  if (fieldConfiguration?.$type !== "Select") {
    const error = `Invalid configuration for Select field: ${fieldConfiguration?.$type}`;
    logError(error, "[EntitySelectField]");
    return null;
  }

  return (
    <EntityFieldSelectForTypeComponent
      value={value}
      fieldId={fieldId}
      fieldConfiguration={fieldConfiguration}
      fieldAttributes={fieldAttributes}
      fieldType={fieldConfiguration.fieldType}
      onChange={onChange}
      fieldInputId={fieldInputId}
    />
  );
};

interface EntityFieldSelectForTypeComponentProps extends EntityFieldComponentProps<string> {
  fieldType: EntityOptionFieldType;
}

const EntityFieldSelectForTypeComponent = ({
  value,
  fieldId,
  fieldAttributes,
  fieldType,
  onChange,
  fieldInputId,
}: EntityFieldSelectForTypeComponentProps) => {
  const { dictionaries } = useClientContext();
  const options = getSelectOptionsFromDictionary(fieldType, dictionaries);
  return (
    <EntityFieldSelectComponent
      fieldId={fieldId}
      value={value}
      options={options}
      fieldAttributes={fieldAttributes}
      onChange={(value, validationResult) => onChange(value, fieldId, validationResult)}
      fieldInputId={fieldInputId}
    />
  );
};

export default EntitySelectField;
